<div class="row availability already-talent-container">
  <div class="large-margin"></div>
  <div class="small-11 small-centered medium-6 large-5 columns text-center thank-you">
    <h5 class="non-cap" translate="">{{'gather.already-a-talent.oops' | translate}}</h5>
    <div class="text">{{'gather.already-a-talent.text' | translate}}</div>
    <span><a
      href="mailto:{{jobPosting.clientServiceManagerEmail}}?subject {{jobPosting.jobTitle}}">{{jobPosting.clientServiceManagerEmail}}</a></span>
  </div>
  <div class="small-11 small-centered medium-6 large-5 columns callout availability">
    <div class="row medium-margin">
      <div class="small-centered text-center columns">
        <img src="assets/images/gather/see_more_jobs.png" class="material-icons large" />
      </div>
    </div>
    <div class="row medium-margin">
      <div class="small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.see-more-jobs' | translate}}</h5>
        <div class="text">{{'gather.see-more-jobs-text' | translate}}
        </div>
      </div>
    </div>
    <div class="row medium-margin button-container">
        <button class="medium job-center-button" (click)="goToJobCenter()">{{'gather.visit-job-center' | translate}}</button>
    </div>
  </div>
</div>
